/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const reachEstimateDataSchema = z.object({
	min: z.number(),
	max: z.number(),
})

export type ReachEstimateDataSchema = z.infer<typeof reachEstimateDataSchema>
